import { render, staticRenderFns } from "./HotVideo.vue?vue&type=template&id=3882f445&scoped=true"
import script from "./HotVideo.vue?vue&type=script&lang=js"
export * from "./HotVideo.vue?vue&type=script&lang=js"
import style0 from "./HotVideo.vue?vue&type=style&index=0&id=3882f445&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3882f445",
  null
  
)

export default component.exports